export default "__VITE_ASSET__DvcEi$bf__"